import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLiveChat } from '../contexts/LiveChatContext';

interface BottomNavigationProps {
  onToggleSidebar?: () => void;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({ onToggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { toggleChat, isOpen: isLiveChatOpen } = useLiveChat();

  // Determine active route
  const isActive = (paths: string[]) => {
    return paths.some(path => location.pathname.startsWith(path));
  };

  const navItems = [
    {
      id: 'casino',
      label: 'Casino',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {/* Card 1 (Red) */}
          <rect x="3" y="5" width="7" height="10" rx="1" fill="#ef4444" stroke="currentColor" strokeWidth="1.5" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M5 8h3M5 10.5h3M5 13h3" stroke="#fff" />
          {/* Card 2 (Green) */}
          <rect x="13" y="5" width="7" height="10" rx="1" fill="#22c55e" stroke="currentColor" strokeWidth="1.5" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M15 8h3M15 10.5h3M15 13h3" stroke="#fff" />
        </svg>
      ),
      onClick: () => navigate('/casino'),
      active: isActive(['/casino', '/roulette']),
    },
    {
      id: 'slot',
      label: 'Slot',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
          <circle cx="8" cy="12" r="1.5" fill="currentColor" />
          <circle cx="12" cy="12" r="1.5" fill="currentColor" />
          <circle cx="16" cy="12" r="1.5" fill="currentColor" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M6 8h12M6 16h12" />
        </svg>
      ),
      onClick: () => navigate('/slot'),
      active: isActive(['/slot']),
    },
    {
      id: 'sports',
      label: 'Sports',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {/* Basketball */}
          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" fill="none" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 3v18M3 12h18M5.64 5.64l12.72 12.72M18.36 5.64L5.64 18.36" />
        </svg>
      ),
      onClick: () => navigate('/sports'),
      active: isActive(['/sports', '/live-sports', '/event']),
    },
    // {
    //   id: 'esports',
    //   label: 'Esports',
    //   icon: (
    //     <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    //       {/* Game controller */}
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    //       <circle cx="8" cy="9" r="1" fill="currentColor" />
    //       <circle cx="16" cy="9" r="1" fill="currentColor" />
    //     </svg>
    //   ),
    //   onClick: () => navigate('/esports'),
    //   active: isActive(['/esports', '/live-esports']),
    // },
    {
      id: 'chat',
      label: 'Chat',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      ),
      onClick: () => toggleChat(),
      active: false, // Chat doesn't have an active state based on route
    },
  ];

  return (
    <nav className={`fixed bottom-0 left-0 right-0 z-50 bg-dark-800/95 backdrop-blur-xl border-t border-white/10 lg:hidden ${isLiveChatOpen ? 'hidden' : ''}`}>
      <div className="flex items-center justify-around px-2 py-2">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={item.onClick}
            className={`flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg transition-all duration-200 min-w-[60px] ${
              item.active
                ? 'text-green-500'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <div className={`${item.active ? 'text-green-500' : ''}`}>
              {item.icon}
            </div>
            <span className={`text-[10px] font-medium ${item.active ? 'text-green-500' : 'text-gray-400'}`}>
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNavigation;
